// types
type Types = any;

const appBar: Types = {
  defaultProps: {
    color: 'transparent'
  },

  styleOverrides: {
    root: {
      boxShadow: 'none'
    }
  }
};

export default appBar;
